/* Real Shopify variant, cart and accelerated-checkout adapter. No demo cart. */
(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('et-config').textContent);
  const headerCart = document.getElementById('cart-icon-bubble');
  if (headerCart) headerCart.href = config.cartUrl;
  const testOffer=window.EtPdpTestOffer?.productId===config.productId?window.EtPdpTestOffer:null;
  const testValid=state=>!!testOffer&&state.count>=1&&state.count<=24&&Date.now()<Date.parse(testOffer.expiresAt);
  const first = JSON.parse(document.getElementById('et-variants').textContent);
  const variants = new Map();
  const key = options => JSON.stringify(options);
  const draftKey = 'et-native-draft-' + config.productId;
  let loaded = false, failure = '', busy = false, basket = {items:[], item_count:0}, estimate = 'economy', lastState;
  const store = {
    MAX_PACK:24,
    packPrice:n => n === 1 ? 1900 : n === 2 ? 2500 : n < 5 ? 2000+(n-3)*600 : n*600,
    read:() => ({items:basket.items, delivery:estimate}),
    save:b => {estimate=b.delivery==='fully'?'fully':'economy';},
    totals:() => ({tees:basket.item_count}),
    readDraft:() => {try{return JSON.parse(sessionStorage.getItem(draftKey));}catch{return null;}},
    saveDraft:d => {try{sessionStorage.setItem(draftKey,JSON.stringify(d));}catch{/* Selection remains usable without storage. */}}
  };
  window.EverteeCart=store;
  function showError(message) {
    const el=document.getElementById('et-purchase-error');
    el.textContent=message;el.hidden=!message;
  }
  function chosen(state) {
    const third=state.fabric+(state.finish==='Blank'?' without logo':' with logo');
    return state.tees.slice(0,state.count).map(t=>variants.get(key([t.colour,t.size,third])));
  }
  function lineItems(state) {
    const aggregated=new Map();
    for(const v of chosen(state)) {
      if(!v?.available)throw new Error('One of your selected tees is unavailable. Please change its colour, size or fabric.');
      const item=aggregated.get(v.id)||{id:v.id,quantity:0};
      item.quantity++;aggregated.set(v.id,item);
    }
    return [...aggregated.values()];
  }
  function sync(state) {
    lastState=state;
    const wallet=document.getElementById('et-wallet');
    const help=document.getElementById('express-help');
    const fields=document.getElementById('et-native-fields');
    fields.replaceChildren();
    const sizeReady=state.tees.slice(0,state.count).every(t=>t.size);
    const selection=chosen(state);
    const available=sizeReady&&selection.every(v=>v?.available);
    const expectedUnit=state.fabric==='Premium'?2100:1900;
    const matchingBase=selection.every(v=>v?.price===expectedUnit);
    const gate=loaded&&(config.pricingEnabled||testValid(state))&&config.currency==='GBP'&&!failure;
    const packEnabled=state.count!==5||config.fivePackEnabled===true;
    const ready=gate&&packEnabled&&available&&matchingBase&&!busy;
    document.getElementById('add-button').disabled=!gate||!packEnabled||busy;
    document.getElementById('sticky-add').disabled=!gate||!packEnabled||busy;
    wallet.hidden=!ready||!config.walletEnabled;wallet.inert=!ready||!config.walletEnabled;
    if(failure)help.textContent=failure;
    else if(!loaded)help.textContent='Checking available colours and sizes…';
    else if(testOffer&&!testValid(state))help.textContent=config.reviewCopy.purchase_unavailable;
    else if(!config.pricingEnabled&&!testOffer)help.textContent=config.reviewCopy.purchase_unavailable;
    else if(config.currency!=='GBP')help.textContent=config.reviewCopy.market_gbp;
    else if(!packEnabled)help.textContent=config.reviewCopy.five_unavailable;
    else if(!sizeReady)help.textContent='Choose your sizes to see available payment methods.';
    else if(!available)help.textContent='One of your selections is unavailable. Please choose another colour or size.';
    else if(!matchingBase)help.textContent='The product price has changed. Please contact Evertee before using this offer.';
    else help.textContent='';
    help.hidden=!help.textContent;
    if(!ready)return;
    lineItems(state).forEach((item,index)=>{
      const prefix=index?`shopify-additional-items[${index}]`:'';
      for(const [name,value] of Object.entries(item)){
        const input=document.createElement('input');input.type='hidden';
        input.name=prefix?`${prefix}[${name}]`:name;input.value=String(value);fields.append(input);
      }
    });
  }
  async function responseJSON(response) {
    const data=await response.json();
    if(!response.ok)throw new Error(typeof data.description==='string'?data.description:'Shopify could not update your bag. Please check your selections.');
    return data;
  }
  async function refreshCart() {
    try {
      basket=await responseJSON(await fetch(config.root+'cart.js',{credentials:'same-origin',cache:'no-store'}));
      const count = document.getElementById('bag-count');
      if (count) count.textContent=basket.item_count;
      if (headerCart) {
        const sections = await responseJSON(await fetch(config.root+'?sections=cart-icon-bubble',{credentials:'same-origin',cache:'no-store'}));
        if (typeof sections['cart-icon-bubble'] === 'string') {
          const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html');
          const content = doc.querySelector('.shopify-section');
          if (content) headerCart.replaceChildren(...content.childNodes);
        }
      }
    } catch { /* Adding still performs its own verified cart operation. */ }
  }
  async function add(state) {
    if(busy||state.count===5&&config.fivePackEnabled!==true)return;
    showError('');sync(state);
    if(!loaded||failure||(!config.pricingEnabled&&!testValid(state))||config.currency!=='GBP')return;
    let items;
    try {
      items=lineItems(state);
      if(chosen(state).some(v=>v.price!==(state.fabric==='Premium'?2100:1900)))throw new Error('The product price has changed. Please contact Evertee before ordering this offer.');
    }catch(error){showError(error.message);return;}
    busy=true;sync(state);
    try {
      await responseJSON(await fetch(config.root+'cart/add.js',{
        method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})
      }));
      window.location.assign(config.cartUrl);
    }catch(error){
      showError(error instanceof TypeError?'The connection was interrupted. Check your bag before trying again to avoid adding the same tees twice.':error.message);
      const link=document.createElement('a');link.href=config.cartUrl;link.textContent=' Check my bag';document.getElementById('et-purchase-error').append(link);
      await refreshCart();
    }finally{busy=false;sync(state);}
  }
  async function loadVariants() {
    let page=first, pages=0;
    const visited=new Set();
    while(page){
      for(const v of page.variants)variants.set(key(v.options),v);
      if(!page.next)break;
      const url=new URL(page.next,location.origin);
      if(url.origin!==location.origin||visited.has(url.href)||++pages>20)throw new Error('Could not load all product options. Please reload the page.');
      visited.add(url.href);url.searchParams.set('section_id',config.sectionId);
      const preview=new URL(location.href).searchParams.get('preview_theme_id');
      if(preview)url.searchParams.set('preview_theme_id',preview);
      const res=await fetch(url,{credentials:'same-origin'});
      if(!res.ok)throw new Error('Could not load the remaining product options. Please reload the page.');
      const doc=new DOMParser().parseFromString(await res.text(),'text/html');
      const data=doc.getElementById('et-variants');
      if(!data)throw new Error('Could not load product options. Please reload the page.');
      page=JSON.parse(data.textContent);
    }
    if(variants.size!==first.total)throw new Error('Some product options are missing. Please reload the page.');
    loaded=true;
  }
  const ready=loadVariants().catch(error=>{failure=error.message;showError(failure);});
  window.EtPdp={config,ready,sync,add,refreshCart};
  if(testOffer)setTimeout(()=>{if(lastState)sync(lastState);},Math.max(0,Date.parse(testOffer.expiresAt)-Date.now()));
})();


